import type { CalculatorAccessMap } from "web_myplann/Calculators/Types/CalculatorAccess";
import type {
	QuickCalculatorItem,
	QuickCalculatorType,
} from "web_myplann/Dashboard/Types/QuickCalculator";

export const mapQuickCalculatorItems = (
	types: readonly QuickCalculatorType[],
	access: CalculatorAccessMap | undefined,
): QuickCalculatorItem[] =>
	types
		.filter((type) => access?.[type].isVisible !== false)
		.map((type) => ({
			type,
			isLocked: access?.[type].hasAccess === false,
		}));
